/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-09 15:00:00
 *
 *******************************************************/
//@flow

import React from 'react';
import { Icon } from '@shopify/polaris';
import {
  AppsMinor,
  ExportMinor,
  ImportMinor,
  PlayMinor,
  QuestionMarkMinor,
  ReportMinor,
  StarFilledMinor
} from '@shopify/polaris-icons';
import bookmarkIcon from 'src/assets/images/common/bookmark.svg';

export const TitleHelp = (props: Object) => {
  const {
    onPlay,
    hrefUserManual,
    hrefBestPractice,
    hrefFAQ,
    i18n,
    style = {},
    openStepGuide,
    onAnalytics,
    onImport,
    onExport
  } = props;

  const handleOpenLink = link => {
    window.open(link, '_blank');
  };

  return (
    <div className="BC-Page__Title--Help" style={style}>
      {onPlay && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={onPlay}>
            <Icon source={PlayMinor} color="base" />
          </span>
          <span onClick={onPlay}>{i18n.translate('AdminHTML.Common.Action.watchTutorials')}</span>
        </div>
      )}
      {hrefUserManual && (
        <div className="BC-Page__Title--Help__Item">
          <span className="img">
            <img
              alt="learn-more"
              src={bookmarkIcon}
              onClick={() => handleOpenLink(hrefUserManual)}
            />
          </span>
          <span onClick={() => handleOpenLink(hrefUserManual)}>
            {i18n.translate('AdminHTML.Common.Action.userGuide')}
          </span>
        </div>
      )}
      {hrefFAQ && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={() => handleOpenLink(hrefFAQ)}>
            <Icon source={QuestionMarkMinor} color="base" />
          </span>
          <span onClick={() => handleOpenLink(hrefFAQ)}>
            {i18n.translate('AdminHTML.Common.Action.faqs')}
          </span>
        </div>
      )}
      {hrefBestPractice && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={() => handleOpenLink(hrefBestPractice)}>
            <Icon source={StarFilledMinor} color="base" />
          </span>
          <span onClick={() => handleOpenLink(hrefBestPractice)}>
            {i18n.translate('AdminHTML.Common.Action.bestPractices')}
          </span>
        </div>
      )}
      {openStepGuide && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={() => openStepGuide()}>
            <Icon source={AppsMinor} color="base" />
          </span>
          <span onClick={() => openStepGuide()}>
            {i18n.translate('AdminHTML.Common.Action.stepGuideInstallRecommendation')}
          </span>
        </div>
      )}
      {onAnalytics && (
        <div className="BC-Page__Title--Help__Item" onClick={() => onAnalytics()}>
          <span>
            <Icon source={ReportMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.analytics')}</span>
        </div>
      )}
      {onImport && (
        <div className="BC-Page__Title--Help__Item" onClick={() => onImport()}>
          <span>
            <Icon source={ImportMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.import')}</span>
        </div>
      )}
      {onExport && (
        <div className="BC-Page__Title--Help__Item" onClick={() => onExport()}>
          <span>
            <Icon source={ExportMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.export')}</span>
        </div>
      )}
    </div>
  );
};

export default TitleHelp;
